import { Component, inject, model, Output, EventEmitter } from '@angular/core'; // Import Output and EventEmitter
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Language, Voice } from '../../models/voice.model';
import { AVAILABLE_LANGUAGES, VOICES } from '../../data/voice-data';

@Component({
  selector: 'google-voice-selector',
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonModule, SelectModule],
  templateUrl: './google-voice-selector.html',
  styleUrls: ['./google-voice-selector.scss'],
})
export class VoiceSelectorComponent {
  private readonly dialogRef = inject(DynamicDialogRef, { optional: true });
  private readonly config = inject(DynamicDialogConfig, { optional: true });

  readonly availableLanguages: Language[] = AVAILABLE_LANGUAGES;
  readonly voices: Voice[] = VOICES;

  selectedLanguageCode = model<string | null>(null);
  selectedVoiceId = model<string | null>(null);

  // Add an optional Output event emitter
  @Output() voiceSelected = new EventEmitter<string>();

  constructor() {
    if (this.config?.data) {
      this.selectedVoiceId.set(this.config.data.currentVoiceId ?? null);
      this.selectedLanguageCode.set(this.config.data.currentLanguageCode ?? null);
    }
  }

  selectVoice(): void {
    const languageCode = this.selectedLanguageCode();
    const voiceId = this.selectedVoiceId();

    if (!languageCode || !voiceId) {
      alert('Please select a language and a voice');
      return;
    }

    const voiceD = `${languageCode}-Chirp3-HD-${voiceId}`;

    // Emit the selected voice before closing the dialog
    this.voiceSelected.emit(voiceD);

    // Close the dialog if it was opened as a dialog
    if (this.dialogRef) {
      this.dialogRef.close(voiceD);
    }
  }

  cancel(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
